<template>
  <div>
    <el-card>
      <page-main
        :tableData="tableData"
        :tablePage="page"
        :loading="loading"
        @reload="reload"
        @openEditFormDialog="openEditFormDialog"
      >
        <page-header
          ref="header"
          slot="header"
          @query="getData"
          @reset="resetPage"
          @openEditFormDialog="openEditFormDialog"
        />
        <pagination
          size="mini"
          align="right"
          slot="pager"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </page-main>
      <el-dialog
        v-if="editFormDialogOptions.visible"
        show-close
        visible
        width="700px"
        :title="editFormDialogOptions.title"
        :close-on-click-modal="false"
        :before-close="() => $refs.editForm.cancel()"
        v-el-dialog-drag
      >
        <sample-options-edit-form
          ref="editForm"
          :optionCode="editFormDialogOptions.optionCode"
          :metadataType="editFormDialogOptions.metadataType"
          :upOptionCode="editFormDialogOptions.upOptionCode"
          :disabled="editFormDialogOptions.disabled"
          :params="editFormDialogOptions.params"
          @reload="reload"
          @close="closeEditFormDialog"
        />
        <span slot="footer">
          <el-button size="small" @click="$refs.editForm.cancel()">{{
            this.$l('INDEX.btn_cancel') || '取消'
          }}</el-button>
          <el-button
            type="primary"
            size="small"
            @click="$refs.editForm.save()"
            v-if="!editFormDialogOptions.disabled"
            >{{ this.$l('INDEX.btn_save') || '保存' }}</el-button
          >
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import SampleOptionsEditForm from '../options-edit-form/index'
import store from '../../store'
export default {
  components: {
    PageHeader,
    PageMain,
    SampleOptionsEditForm
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        optionCode: '',
        companyCode: ''
      }
    }
  },
  computed: {
    selected() {
      return store.state.selected
    }
  },
  watch: {
    selected() {
      this.getData()
    }
  },
  methods: {
    getData(form) {
      if (!this.selected || !this.selected.metadataType) return
      this.loading = true
      this.$api
        .sampleMetadataOptionsListApi({
          metadataType: this.selected.metadataType,
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, params = {} }) {
      if (!this.selected || !this.selected.metadataType) {
        this.$message.warning(
          this.$l('form_label_tip_select_metadataType') || '请选择一个样品属性'
        )
        return
      }
      const types = {
        edit:
          this.$l('form_label_metadata_options_edit') || '编辑样品属性选项信息',
        add:
          this.$l('form_label_metadata_options_add') || '添加样品属性选项信息',
        detail:
          this.$l('form_label_metadata_options_detail') ||
          '样品属性选项信息详情'
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        optionCode: params.optionCode,
        metadataType: this.selected.metadataType,
        upOptionCode: this.selected.metadataCode,
        disabled: type === 'detail'
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    }
  }
}
</script>
